import { render, staticRenderFns } from "./CrudComponent.vue?vue&type=template&id=e968f73a&"
import script from "./CrudComponent.vue?vue&type=script&lang=js&"
export * from "./CrudComponent.vue?vue&type=script&lang=js&"
import style0 from "./CrudComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports